<template>
	<div class="create-task-container pb-4">
		<div v-if="job || isLogTimesheet" class="top-line"></div>
		<div v-if="job || isLogTimesheet" class="pt-3 px-6 task-title">
			<div class="title-text">
				<span v-if="isAddTimesheet_local">Add Timesheet</span>
				<span v-if="!isAddTimesheet_local">Timesheet</span>
			</div>
			<div class="task-title">
				<v-menu v-if="editItem && !isAddTimesheet_local && amendTimesheetPrivilege && isJobValid && !restrictedPrivilege" v-model="menu" offset-y nudge-bottom="8" nudge-left="12" :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn class="px-0 rounded-pill mr-2" max-height="24" v-bind="attrs" v-on="on">
							<v-progress-linear v-if="!ts_for" :color="color" indeterminate></v-progress-linear>
							<v-user-avatar
								v-if="ts_for"
								size="24"
								class="text-caption text-decoration-none"
								:code="ts_for.display_name"
								:image="`/api/addressbook/${ts_for.id}/image.png`"
							/>
							<div v-if="ts_for" class="step-item-text text-capitalize mx-2">{{ ts_for.display_name }}</div>
							<v-icon class="mr-1" small color="rgba(25, 42, 62, 0.5)">mdi-pencil</v-icon>
						</v-btn>
					</template>
					<v-card elevation="0" color="transparent">
						<v-text-field
							v-model="for_saech"
							style="position: relative"
							:color="color"
							background-color="#FAFAFA"
							prepend-inner-icon="mdi-magnify"
							outlined
							dense
							hide-no-data
							hide-details
							rows="1"
							min-width="auto"
							@input="onForSaechChange($event)"
						>
						</v-text-field>
						<v-card-text class="mt-1 pa-0 tree-wrap rounded" style="background-color: #FAFAFA;">
							<v-list nav dense class="tree-wrap-container">
								<v-list-item
									class="for-item-text-hover"
									v-for="(item, i) in for_saech_items"
									:key="i"
									dense
									@click="onForSaechClick(item)"
								>
									<span v-if="ts_for" :style="`color: ${item.id === ts_for.id ? color:''}`">{{ item.display_name }}</span>
								</v-list-item>
							</v-list>
						</v-card-text>
					</v-card>
				</v-menu>
				<Copy v-if="isFromOmins && editItem && !isAddTimesheet_local && isJobValid" class="mr-2" :class="editItem && !amendTimesheetPrivilege ? '':'step-item-text-hover'"  style="height: 16px; width: 16px" :color="editItem && !amendTimesheetPrivilege ? 'rgba(25, 42, 62, 0.4)':'rgba(25, 42, 62, 0.7)'" @click="onCopyTimesheet()"/>
				<Delete v-if="isFromOmins && editItem && !isAddTimesheet_local && deleteTimesheetPrivilege" class="mt-1" :class="editItem && !amendTimesheetPrivilege ? '':'step-item-text-hover'" style="height: 20px; width: 20px" :color="editItem && !amendTimesheetPrivilege ? 'rgba(25, 42, 62, 0.4)':'rgba(25, 42, 62, 0.7)'" @click="onDeleteTimesheet()"/>
				<v-icon @click.stop="onEditTimesheetClose()">mdi-close</v-icon>
			</div>
		</div>
		<v-alert class="mx-6 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ errorMessageFormat(error_msg) }}
		</v-alert>
		<div v-if="search_more" class="px-6">
			<v-btn text plain class="px-0 text-capitalize" @click="onBack()">
				<v-icon>mdi-chevron-left</v-icon>
				Back
			</v-btn>
			<ProgressLinear v-if="loading" />
			<template v-else>
				<template v-if="!search_flag">
					<div class="mt-2 mb-1 step-item-text">Client</div>
					<v-autocomplete
						style="width: 100%"
						v-model="job_client"
						:items="client_items"
						:color="color"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						item-text="display_name"
						item-value="id"
						item-color="success"
						outlined
						multiple
						dense
						hide-details
						return-object
						chips
					>
						<template v-slot:prepend-inner>
							<ClientIcon style="margin-top: 2px" color="rgba(25, 42, 62, 0.5)" width="24" height="24"/>
						</template>
						<template v-slot:selection="data">
							<v-chip
								v-bind="data.attrs"
								:input-value="data.selected"
								close
								@click="data.select"
								@click:close="removeClient(data.item)"
							>
								{{ data.item.display_name }}
							</v-chip>
						</template>
					</v-autocomplete>
					<div class="mt-4 mb-1 step-item-text">Job Status</div>
					<v-autocomplete
						style="width: 100%"
						v-model="job_status"
						:items="status_items"
						:color="color"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						item-text="desc"
						item-value="id"
						item-color="success"
						outlined
						multiple
						dense
						hide-details
						return-object
						chips
					>
						<template v-slot:prepend-inner>   
							<SuitCase style="margin-top: 2px" color="rgba(25, 42, 62, 0.5)" width="20" height="20"/>
						</template>
						<template v-slot:selection="data">
							<v-chip
								v-bind="data.attrs"
								:input-value="data.selected"
								close
								@click="data.select"
								@click:close="removeStatus(data.item)"
							>
								{{ data.item.desc }}
							</v-chip>
						</template>
					</v-autocomplete>
					<div class="mt-4 mb-1 step-item-text">Job Types</div>
					<v-autocomplete
						style="width: 100%"
						v-model="job_type"
						:items="type_items"
						:color="color"
						:menu-props="{ bottom: true, offsetY: true}"
						background-color="#FAFAFA"
						item-text="desc"
						item-value="id"
						item-color="success"
						outlined
						multiple
						dense
						hide-details
						return-object
						chips
					>
						<template v-slot:prepend-inner>   
							<SuitCase style="margin-top: 2px" color="rgba(25, 42, 62, 0.5)" width="20" height="20"/>
						</template>
						<template v-slot:selection="data">
							<v-chip
								v-bind="data.attrs"
								:input-value="data.selected"
								close
								@click="data.select"
								@click:close="removeTypes(data.item)"
							>
								{{ data.item.desc }}
							</v-chip>
						</template>
					</v-autocomplete>
					<v-btn block class="mt-4 mb-1 text-capitalize white--text" color="#00AAFD" :disabled="!isSearchMoreActive" @click="onJobSearch()">
						<v-icon class="mr-1">mdi-magnify</v-icon>
						Search
					</v-btn>
				</template>
				<template v-if="search_flag">
					<v-data-table
						:headers="headers"
						:items="job_items"
						:height="300"
						hide-default-footer
						disable-sort
						:items-per-page="-1"
						@click:row="onJobSelected($event, true)"
					></v-data-table>
				</template>
			</template>
		</div>
		<div v-if="!search_more" class="px-6" @click="close_selection += 1">
			<ProgressLinear v-if="loading" />
			<template v-else>
				<v-row v-if="(!editItem || isAddTimesheet_local) && !restrictedPrivilege" class="ma-0" style="width: 100%">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0'">
						<div class="step-item-text step-item-text-able mt-4">Timesheet for</div>
						<v-select
							v-model="ts_for"
							:loading="loading_ts"
							:items="ts_for_items"
							:color="color"
							:disabled="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)"
							background-color="#FAFAFA"
							item-text="display_name"
							item-value="id"
							item-color="success"
							outlined
							dense
							hide-details
							return-object
							@change="onTsForChange()"
						>
							<template v-slot:selection="{ item, index }">
								<v-chip label v-if="index === 0">
									<span>{{ item.display_name }}</span>
								</v-chip>
							</template>
						</v-select>
					</v-col>
					<v-col v-if="is_toggle" :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pr-0'">
						<div class="step-item-text step-item-text-able mt-4">Timesheet type</div>
						<v-btn-toggle v-model="ts_type" mandatory borderless @change="onTypeChange()">
							<v-btn
								class="mr-5 rounded text-capitalize"
								:class="ts_type == employee_type ? 'white--text':''"
								:color="ts_type == employee_type ? color:'#FFFFFF'"
								:value="employee_type"
								depressed
								min-height="40" 
								max-height="40"
							>
								Employee
							</v-btn>
							<v-btn
								class="rounded text-capitalize"
								:class="ts_type == freelancer_type ? 'white--text':''"
								:color="ts_type == freelancer_type ? color:'#FFFFFF'"
								:value="freelancer_type"
								depressed 
								min-height="40" 
								max-height="40" 
							>
								Freelancer
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<div class="mt-4" :class="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid) ? 'step-item-text-disable':'step-item-text step-item-text-able'" :style="error_job_flag ? 'color:#F45252':''">Job</div>
				<v-autocomplete
					v-model="job_selected"
					ref="job"
					:items="job_items"
					:loading="loading_job"
					:search-input.sync="jobSearch"
					:color="color"
					:error="error_job_flag"
					background-color="#FAFAFA"
					item-text="display_name"
					item-value="id"
					item-color="success"
					item-disabled="disabled"
					auto-select-first
					outlined
					dense
					hide-details
					hide-no-data
					return-object
					clearable
					:disabled="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)"
					@change="onJobSelected($event)"
				>
					<template v-slot:prepend-inner>   
						<SuitCase :color="error_job_flag ? '#F45252': 'rgba(25, 42, 62, 0.5)'" width="24" height="24"/>
					</template>
				</v-autocomplete>
				<v-row class="ma-0" justify="end">
					<div :class="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege ||!isJobValid ) ? 'optional-text-disable search-text-disable':'optional-text search-text'" @click="onSearchMore()">Search by Client or Job type</div>
				</v-row>
				<v-progress-linear v-if="loading_phase_task" class="mt-3" :color="color" indeterminate></v-progress-linear>
				<v-row v-if="warn_msg.length !== 0" class="my-1 mx-0 px-3">
					<div>
						<v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
						<span class="step-item-text" style="color: rgba(244, 82, 82, 1)">{{ warn_msg }}</span>
					</div>
				</v-row>
				<v-row v-if="!isJobValid" class="my-1 mx-0 px-3">
					<div>
						<v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
						<span class="step-item-text" style="color: rgba(244, 82, 82, 1)">Time cannot be added to a complete, cancelled or dead job</span>
					</div>
				</v-row>
				<template v-if="!loading_phase_task">
					<div v-if="is_only_phase" class="mb-1" :class="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid) ? 'step-item-text-disable':'step-item-text step-item-text-able'" :style="error_phase_flag ? 'color:#F45252':''">Phase</div>
					<v-select
						v-if="is_only_phase"
						v-model="phase"
						:items="phase_items"
						:color="color"
						:error="error_phase_flag"
						:disabled="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)"
						background-color="#FAFAFA"
						item-text="desc"
						item-value="id"
						item-color="success"
						outlined
						dense
						hide-details
						return-object
						@change="onPhaseChange()"
					>
						<template v-slot:prepend-inner>   
							<Phase :color="error_phase_flag ? '#F45252' : 'rgba(25, 42, 62, 0.5)' "/>     
						</template>
						<template v-slot:item="{item, on}">
							<v-list-item style="min-height: 32px">
								<div class="step-item-text step-item-text-hover" :style="item.completed ? 'color: rgba(25, 42, 62, 0.5)':'color: rgba(25, 42, 62, 1)'" v-on="on">{{ item.desc }}</div>
							</v-list-item>
						</template>
					</v-select>
				</template>
				<v-row v-if="!is_only_phase" class="ma-0">
					<v-col :cols="$vuetify.breakpoint.xsOnly || !is_second_step_phase ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly || !is_second_step_phase ? 'px-0' : 'pl-0'">
						<div :class="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid) ? 'step-item-text-disable':'step-item-text step-item-text-able'" :style="error_task_name_flag ? 'color:#F45252':''">Task Name</div>
						<v-select
							style="width: 100%"
							v-model="task"
							:items="task_items"
							:color="color"
							:error="error_task_name_flag"
							:disabled="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)"
							background-color="#FAFAFA"
							item-text="description"
							item-value="id"
							item-color="success"
							outlined
							dense
							hide-details
							return-object
							@change="onTaskChange($event)"
						> 
							<template v-slot:item="{item, on}">
								<v-list-item style="min-height: 32px">
									<div v-if="item.id === 0" class="step-item-text step-item-text-hover" style="color: rgba(25, 42, 62, 1)" v-on="on">{{ item.description }}</div>
									<div v-if="item.id !== 0 && item.phase" class="step-item-text step-item-text-hover" :style="item.status.type === status_completed_type ? 'color: rgba(25, 42, 62, 0.5)':'color: rgba(25, 42, 62, 1)'" v-on="on">
										<span>{{ item.description }}</span>
										<v-chip v-if="item.status.type === status_completed_type" x-small class="ml-3">{{ item.status.name }}</v-chip>
									</div>
									<v-row v-if="item.id !== 0 && !item.phase" class="mt-2 mb-0">
										<v-col cols="12" class="py-0">
											<div class="step-item-text" style="font-weight: 500; color: rgba(25, 42, 62, 0.5)">{{ item.description }}</div>
										</v-col>
										<v-col cols="12" class="pt-1 pb-0">
											<v-divider></v-divider>
										</v-col>
									</v-row>
								</v-list-item>
							</template>
						</v-select>
					</v-col>
					<v-col v-if="is_second_step_phase" :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pr-0'">
						<div class="step-item-text" :class="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid) ? 'step-item-text-disable':'step-item-text step-item-text-able'" :style="error_phase_flag ? 'color:#F45252':''">Phase</div>
						<v-select
							v-model="phase"
							:items="phase_items"
							:color="color"
							:error="error_phase_flag"
							:disabled="editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)"
							background-color="#FAFAFA"
							item-text="desc"
							item-value="id"
							item-color="success"
							outlined
							dense
							hide-details
							return-object
							@change="onPhaseChange()"
						>
							<template v-slot:prepend-inner>   
								<Phase :color="error_phase_flag ? '#F45252' : 'rgba(25, 42, 62, 0.5)' "/>     
							</template>
							<template v-slot:item="{item, on}">
								<v-list-item style="min-height: 32px">
									<div class="step-item-text step-item-text-hover" :style="item.completed ? 'color: rgba(25, 42, 62, 0.5)':'color: rgba(25, 42, 62, 1)'" v-on="on">{{ item.desc }}</div>
								</v-list-item>
							</template>
						</v-select>
					</v-col>
				</v-row>
				<v-row class="ma-0" style="width: 100%">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0'">
						<div class="step-item-text" :class="[(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 ? 'step-item-text-disable':'step-item-text-able', $vuetify.breakpoint.xsOnly? 'mt-4':'mt-5']" :style="error_date_flag ? `color:#F45252`:``">Date</div>
						<DatePicker
							:style="$vuetify.breakpoint.xsOnly ? 'width: 100%': ''"
							:isOutlined="true"
							:isIcon="true"
							:background="'#FAFAFA'"
							:color="color"
							:error="error_date_flag"
							:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0"
							:dateInit="timesheet_date"
							@date="onDateChange($event)"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pr-0'">
						<div class="mt-5 step-item-text" :class="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 || (task && task.id !== 0 && task.kind !== null && task.kind.id !== null && !error_limit_kind_flag) ? 'step-item-text-disable':'step-item-text-able'" :style="isJobValid && (error_kind_flag || error_limit_kind_flag) ? 'color:#F45252':''">Kind</div>
						<KindTreeSelection
							ref="kind"
							:class="error_kind_flag || error_limit_kind_flag ? '': 'mb-4'"
							:key="'timesheet_kindtree'"
							:isKindIcon="true"
							:color="color"
							:bgColor="'#FAFAFA'"
							:kindParams="kind_params"
							:kindSelected="kind_selected"
							:closeSelection="close_selection"
							:isWidthAuto="true"
							:error="isJobValid && (error_kind_flag || error_limit_kind_flag)"
							:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 || (task && task.id !== 0 && task.kind !== null && task.kind.id !== null && !error_limit_kind_flag)"
							@no-data="onNoData($event)"
							@kind-selected="onKindChange($event)"
						/>
						<div v-if="isJobValid && error_limit_kind_flag" class="optional-text-red">
							<v-icon small color="error">close</v-icon>
							<span style="vertical-align: middle">Select only from Kinds quoted or for which tasks exist</span>
						</div>
						<div v-if="!error_limit_kind_flag && error_kind_flag" style="text-align: right" class="optional-text-red">required</div>
					</v-col>
				</v-row>
				<v-row class="mx-0 mt-0">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:4" class="px-0" :class="$vuetify.breakpoint.xsOnly ? '':''">
						<div class="step-item-text" :class="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 ? `step-item-text-disable`:`step-item-text-able`" :style="error_duration_flag || error_duration_over_flag ? `color:#F45252`:``">Duration</div>
						<v-text-field
							:class="error_duration_over_flag ? 'duration': ''"
							v-model="duration"
							ref="duration"
							:color="color"
							background-color="#FAFAFA"
							:rules="rules"
							:error="error_duration_flag || error_duration_over_flag"
							:error-messages="error_duration_over_flag ? 'More than time remaining today. Clear Start/End time.' : ''"
							:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0"
							placeholder="eg, 10h 15m or 10:15"
							outlined
							dense
							clearable
							:hide-details="error_duration_over_flag ? false : true"
							@change="onDurationChange($event)"
							@keydown="onKeydown($event)"
						></v-text-field>
					</v-col>
					<v-col v-if="!$vuetify.breakpoint.xsOnly" :cols="1" align-self="center">
						<v-icon>mdi-swap-horizontal</v-icon>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="pa-0">
						<DateTime
							:color="color"
							:duration="duration ? duration : ''"
							:startTimeInit="time_start_init"
							:endTimeInit="time_end_init"
							:timeOverage="isBeyond"
							:startError="start_time_error"
							:errorStartFlag="error_start_flag"
							:endError="end_time_error"
							:errorEndFlag="error_end_flag"
							:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0"
							@time_start="onTimeStartChange($event)"
							@time_end="onTimeEndChange($event)"
							@keydown="onKeydown($event)"
						/>
					</v-col>
				</v-row>
				<v-row class="ma-0" justify="space-between">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:11" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pt-0 pb-1 pl-0'">
						<v-progress-linear v-if="loading_duration" class="mt-2" :color="color" indeterminate></v-progress-linear>
						<div v-if="!loading_duration" class="task-title">
							<div class="duration-text">
								<span :class="task_left.includes('-') ? 'duration-text-over':'duration-text-normal'" style="font-weight: 700">{{ task_left }}&nbsp;</span>
								<span class="duration-text-grey">left</span>
							</div>
							<div class="duration-text">
								<span class="duration-text-dark-grey" style="font-weight: 700">{{ task_actual }} / {{ task_budget }}&nbsp;</span>
								<span class="duration-text-grey">used</span>
							</div>
						</div>
					</v-col>
				</v-row>
				<v-row class="ma-0">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:6" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : 'pl-0'">
						<div class="step-item-text" :class="[(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 || !task || (task && task.id === 0) ? 'step-item-text-disable':'step-item-text-able', $vuetify.breakpoint.xsOnly ? '':'mt-4']" :style="error_task_status_flag ? 'color:#F45252':''">Task Status</div>
						<v-select
							v-model="task_status"
							:color="color"
							:error="error_task_status_flag"
							background-color="#FAFAFA"
							:items="task_statuses"
							item-text="desc"
							item-value="id"
							item-color="success"
							outlined
							dense
							hide-details
							return-object
							:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || !task || (task && task.id === 0)"
							@change="onTaskStatusChange()"
						>
							<template v-slot:selection="{ item }">
								<span>
									<v-badge
										:color="item.color"
										left
										inline
									>
										<span class="ml-1">{{ item.desc }}</span>
									</v-badge>
								</span>
							</template>
							<template v-slot:item="{item, on}">
								<v-list-item v-on="on" dense>
									<v-badge
										:color="item.color"
										left
										inline
									>
										<span class="ml-1">{{ item.desc }}</span>
									</v-badge>					
								</v-list-item>
							</template>
						</v-select>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12:2" class="py-0" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : ''">
						<div class="step-item-text" :class="$vuetify.breakpoint.xsOnly ? '':'mt-4'">Mark as</div>
						<v-btn-toggle v-model="ac_oc" borderless @change="onDescriptionChange()">
							<v-btn
								class="mr-2 rounded"
								:class="isTaskAcOc && ac_oc == ac_type ? 'disabled-color':''"
								:color="ac_oc == ac_type ? 'rgba(129, 204, 0, 0.25)':''"
								:value="ac_type"
								:disabled="isTaskAcOc"
								depressed
								min-width="44" 
								max-width="44" 
								min-height="40" 
								max-height="40"
							>
								AC
							</v-btn>
							<v-btn
								class="rounded"
								:class="isTaskAcOc && ac_oc == oc_type ? 'disabled-color':''"
								:color="ac_oc == oc_type ? 'rgba(129, 204, 0, 0.25)':''"
								:value="oc_type"
								:disabled="isTaskAcOc"
								depressed 
								min-width="44" 
								max-width="44" 
								min-height="40" 
								max-height="40" 
							>
								OC
							</v-btn>
						</v-btn-toggle>
					</v-col>
					<v-col v-if="editItem && !isAddTimesheet_local && amendTimesheetPrivilege && isJobValid && !restrictedPrivilege && is_toggle" 
						:cols="$vuetify.breakpoint.xsOnly ? 12:4"
						class="py-0" 
						:class="$vuetify.breakpoint.xsOnly ? 'px-0' : ''"
					>
						<div class="step-item-text" :class="$vuetify.breakpoint.xsOnly ? '':'mt-4'">Timesheet type</div>
						<v-btn-toggle v-model="ts_type" mandatory borderless @change="onTypeChange()">
							<v-btn
								class="mr-5 rounded text-capitalize"
								:class="ts_type == employee_type ? 'white--text':''"
								:color="ts_type == employee_type ? color:'#FFFFFF'"
								:value="employee_type"
								depressed
								min-height="40" 
								max-height="40"
							>
								Employee
							</v-btn>
							<v-btn
								class="rounded text-capitalize"
								:class="ts_type == freelancer_type ? 'white--text':''"
								:color="ts_type == freelancer_type ? color:'#FFFFFF'"
								:value="freelancer_type"
								depressed 
								min-height="40" 
								max-height="40" 
							>
								Freelancer
							</v-btn>
						</v-btn-toggle>
					</v-col>
				</v-row>
				<div class="mt-5 mb-1 step-item-text" :class="[(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0 ? `step-item-text-disable`:`step-item-text-able`, $vuetify.breakpoint.xsOnly? 'mt-0':'mt-0']">Description</div>
				<v-textarea
					v-model="notes"
					style="width: 100%;"
					:rows="2"
					:color="color"
					:disabled="(editItem && !isAddTimesheet_local && (!amendTimesheetPrivilege || !isJobValid)) || warn_msg.length !== 0"
					outlined
					dense
					hide-details
					clear-icon
					background-color="#FAFAFA"
					@change="onDescriptionChange()"
					@keydown="onKeydownDesc($event)"
				></v-textarea>
				<v-col v-if="isJobValid && itemsEnabledPrivilege && warn_msg.length === 0" cols="12" class="px-0 mt-2 mb-1">
					<LogItem
						:color="color"
						:showRates="ratesPrivilege"
						:currencies="currencies" 
						:job="job_selected"
						:date="timesheet_date"
						:itemParams="item_params"
						@items-change="onItemsChange($event)"
						@error-msg="error_msg = $event"
					/>
				</v-col>
				<div @click="checkDurationUnactive()">
					<v-btn v-if="!editItem && !job" :disabled="!isActive" depressed block class="text-capitalize white--text my-4" color="#00AAFD" @click="onCreateTimeSheet()">
						<span>Create Timesheet</span>
					</v-btn>
				</div>
				<div @click="checkDurationUnactive()">
					<v-btn v-if="(job || editItem) && isAddTimesheet_local" :disabled="!isActive" depressed block class="text-capitalize white--text my-4" color="#00AAFD" @click="onCreateTimeSheet()">
						<span>Add Timesheet</span>
					</v-btn>
				</div>
				<div @click="checkDurationUnactive()">
					<v-btn v-if="editItem && !isAddTimesheet_local" :disabled="!isActive" depressed block class="text-capitalize white--text my-4" color="#00AAFD" @click="onUpdateTimeSheet()">
						<span>Save Changes</span>
					</v-btn>
				</div>				
				<DialogNotice
					v-if="visible_notice" 
					:visible="visible_notice" 
					:text="notice_text"
				/>
				<DeleteConfirmDialog 
					v-if="unsaved_visible"
					:visible="unsaved_visible" 
					:color="'error'"
					:title="`Unsaved changes`" 
					:content="'Are you sure you want to leave this window without saving changes?'"
					:ok="'Yes, exit'"
					:icon_name_title="'mdi-alert-circle'"
					:icon_name_front="'mdi-delete-outline'"
					:maxWidth="500"
					@cancel="unsaved_visible = false"
					@ok="$emit('cancel-timesheet')"
				/>
			</template>
		</div>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="`You are about to delete this Timesheet.`" 
			:content="`This action cannot be undone. Are you sure?`"
			:ok="'Yes, delete'"
			:icon_name_title="'mdi-alert-circle'"
			:icon_name_front="'mdi-delete-outline'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDelete($event)"
		/>
	</div>
</template>
<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";

import SuitCase from "@/components/icons/suitcase.vue";
import ClientIcon from "@/components/icons/client.vue";
import Copy from '@/components/icons/copy';
import Delete from '@/components/icons/delete_outline';
import Phase from "@/components/icons/phase.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import DatePicker from "@/components/date/date_picker.vue";
import DateTime from "@/components/date/date_time.vue";

import LogItem from "@/views/items/log_item.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

import { validTime } from "@/common/validTime.js";
import { validHour } from "@/common/validHour.js";
import { budgetToMinutes, minutesToBudget } from "@/common/budgetToMinute.js";

import moment from 'moment';
import config from "@/config.js";

const DescriptionLimit = 60;
const Completed_Phase = 1;
const Setting_Name = 'NewTimesheet';

const JOr = 'JOr';
const TPc = 'TPc';
const TSr = 'TSr';
const CH = 'CH';

/** If selected the user will be able to enter and amend timesheets */
const TS = 'TS';

/** If selected, the user is allowed to delete timesheet entries */
const TsD = 'TsD';

/** Limit kinds to quoted or for which tasks exists */
const TSk = 'TSk';

/** Restricted to own time, If selected, user will only be allow to amend items their own timesheets. */
const TsS = 'TsS';

/** license_type, 2 = 'ATS user', 3 = 'ATS+ user' */
const ATS = 'ATS';

const HEADERS = [
	{ text: 'Job No.', value: 'res_code' },
	{ text: 'Job Title', value: 'res_short' },
	{ text: 'Job Type', value: 'res_type' },
	{ text: 'Job Status', value: 'res_status' },
];

const No_Related_Task = {id: 0, description: 'No related task'};


/** 0-employee,1-talent,2-freelancer */
const Employee_Type = 0;
const Freelancer_Type = 2;

/** 0-'',1-AC,2-OC */
const AC_Type = 1;
const OC_Type = 2;

const Any_Mode = 1;
const Overhead_Mode = 2;

const Keydown_Key = 13;
const Keydown_Code_Num = 'NumpadEnter';

const Warning_Note = 'Timesheets cannot be created as there is no accepted estimate or task on this job. Please contact your manager if you need to put time on this job.';

export default {
	name: 'NewTimeSheet',
	props: {
		job: {
			type: Object,
			default: null,
		},
		editItem: {
			type: Object,
			default: null,
		},
		isAddTimesheet: {
			type: Boolean,
			default: false,
		},
		isLogTimesheet: {
			type: Boolean,
			default: false,
		},
		joid: {
			type: Number,
			default: 0
		},
		adbid: {
			type: Number,
			default: 0
		},
		tasid: {
			type: Number,
			default: 0
		},
		startTime: {
			type: String,
			default: ''
		},
		endTime: {
			type: String,
			default: ''
		}
	},
	components: {
		ProgressLinear,
		SuitCase,
		ClientIcon,
		Delete,
		Copy,
		Phase,
		KindTreeSelection,
		DatePicker,
		DateTime,
		LogItem,
		DialogNotice,
		DeleteConfirmDialog,
	},
	data() {
		this.status_completed_type = config.status_completed_type;
		this.employee_type = Employee_Type;
		this.freelancer_type = Freelancer_Type;
		this.ac_type = AC_Type;
		this.oc_type = OC_Type;

		return {
			loading: false,
			loading_ts: false,
			loading_job: false,
			loading_phase_task: false,
			loading_duration: false,

			error_msg: '',
			warn_msg: '',
			color: this.$attrs.color ?  this.$attrs.color : '#81CC00',
			close_selection: 0,
			userId: 0,
			isAddTimesheet_local: this.isAddTimesheet,
			timesheet_settings: null,

			search_more: false,
			search_flag: false,
			job_invalid_status_ids: [],

			job_client: [],
			client_items: [],
			job_status: [],
			status_items: [],
			job_type: [],
			type_items: [],
			headers: HEADERS,

			ts_for: null,
			ts_for_items: [],
			is_toggle: false,
			ts_type: Employee_Type,
			timesheet_by_id: null,

			menu: false,
			for_saech: '',
			for_saech_items: [],

			job_selected: { id: 0, display_name: '', valid: true },
			job_items: [],
			jobSearch: null,

			
			is_only_phase: false,
			is_second_step_phase: false,
			phase: null,
			phase_items: [],

			task: null,
			task_items: [],

			task_status: null,
			task_statuses: [],

			kind: { id: 0, display_name: '' },
			kind_selected: null,
			kind_params: {
				select_kinds: true,
				select_items: false,
				timesheet_kinds: true,
				overhead_mode: 0,
			},

			timesheet_date: moment().format('YYYY-MM-DD'),

			duration: '',
			menu_start_time: false,
			menu_end_time: false,
			time_start: null,
			time_end: null,
			time_start_init: '',
			time_end_init: '',

			task_budget_type: 0,
			task_left: '',
			task_budget: '',
			task_actual: '',

			item_params: {
				select_kinds: false,
				select_items: true,
				overhead_mode: 0,
			},
			items: [],
			currencies: [],
			ac_oc: null,
			task_acoc: 0,

			notes: '',
			notes_type: '',
			
			visible_notice: false,
			notice_text: [],
			tid: null,

			delete_visible: false,

			isActive: this.isAddTimesheet_local ? true : false,
			unsaved_visible: false,

			start_time_error: false,
			end_time_error: false,

			error_job_flag: false,
			error_phase_flag: false,
			error_task_name_flag: false,
			error_task_status_flag: false,
			error_kind_flag: false,
			error_limit_kind_flag: false,
			error_date_flag: false,
			error_start_flag: false,
			error_end_flag: false,
			error_duration_flag: false,
			error_duration_over_flag: false,
			button_click_flag: false,
			
			rules: [
				value => {
					return validHour(value);
				}
			]
		}
	},
	watch: {
		jobSearch(val) {
			val && (this.job_selected ?  val !== this.job_selected.display_name : true) && this.jobQuery(val);
		},
		job_selected(new_val, old_val) {
			if (this.job_selected === null) {				
				this.kind_params.overhead_mode = 0;
			}
			if ((new_val && old_val && old_val.id !== 0 && new_val.id !== old_val.id) || (new_val && old_val === null)) {
				this.tid = setTimeout(this._checkLimitKind, 1000);
			}
		},
		ts_for() {			
			const adbid = this.ts_for ? this.ts_for.id : this.user_abid;

			this.getAbookJson(adbid)
				.then((val) => {
					this.is_toggle = val.employee_active && val.freelancer_active ? true : false;

					if (val.employee_active && !val.freelancer_active) {
						this.ts_type = Employee_Type;						
					}
					if (!val.employee_active && val.freelancer_active) {
						this.ts_type = Freelancer_Type;						
					}
					if (val.employee_active && val.freelancer_active) {
						if (typeof(this.ts_type) === 'boolean') {
							if (this.ts_type === true) {
								this.ts_type = Freelancer_Type;
							} else if (this.ts_type === false) {
								this.ts_type = Employee_Type;	
							} else {
								this.ts_type = Employee_Type;			
							}
						}
					}
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		kind() {
			if (this.editItem) {
				if (!this.editItem.task) {
					this.getActualsQuoted(this.editItem.phase.id, this.editItem.kind.id, this.job_selected.currency.id);
				}
			} else {
				if (this.kind && this.kind.id !== 0 && this.phase && this.phase.id && this.job_selected && this.job_selected.id !== 0) {
					const task_id = this.task && this.task.id !== 0 ? this.task.id : 0;
					if (task_id === 0) {
						this.getActualsQuoted(this.phase.id, this.kind.id, this.job_selected.currency.id, task_id);
					}
				}
			}
		}
	},
	computed: {
		user_type() {
			let user_type = 0;

			if (this.$store.state.user) {
				user_type = this.$store.state.user.license_type;
			}		

			return user_type;
		},
		user_abid() {
			let abid = 0;

			const user = this.$store.state.user;

			if (user && user.addressbook) {
				abid = user.addressbook.id;
			}		

			return abid;
		},
		amendTimesheetPrivilege() {
			let isAmendTimesheetTpm = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TS)) {
				isAmendTimesheetTpm = true;
			}
			return isAmendTimesheetTpm;
		},
		deleteTimesheetPrivilege() {
			let isDeleteTimesheetTpm = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TsD)) {
				isDeleteTimesheetTpm = true;
			}
			return isDeleteTimesheetTpm;
		},
		completedJobPrivilege() {
			let isCompletedJobTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(JOr)) {
				isCompletedJobTmp = true;
			}
			return isCompletedJobTmp;
		},
		completedPhasePrivilege() {
			let isCompletedPhasesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TPc)) {
				isCompletedPhasesTmp = true;
			}
			return isCompletedPhasesTmp;
		},
		limitKindsPrivilege() {
			let isRatesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TSk)) {
				isRatesTmp = true;
			}
			return isRatesTmp;
		},
		ratesPrivilege() {
			let isRatesTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TSr)) {
				isRatesTmp = true;
			}
			return isRatesTmp;
		},
		itemsEnabledPrivilege() {
			let itemsEnabledTmp = false;
			if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(CH)) {
				itemsEnabledTmp = true;
			}
			return itemsEnabledTmp
		},
		restrictedPrivilege() {
			let isRestricted = false;

			if (this.user_type.includes(ATS)) {
				isRestricted = true;
			} else {
				if (this.$store.state.privileges && this.$store.state.privileges.length !== 0 && this.$store.state.privileges.includes(TsS)) {
					isRestricted = true;
				}
			}
			
			return isRestricted;
		},
		isSearchMoreActive() {
			let isActive = false;

			if (this.job_client.length !== 0 || this.job_status.length !== 0 || this.job_type.length !== 0) {
				isActive = true;
			}

			return isActive;
		},
		isBeyond() {
			let is_beyond = false;

			if ((this.duration !== 0 || (typeof(this.duration) === 'string' && this.duration.length !== 0)) && this.time_start && this.time_start.length !== 0) {
				const start = moment(this.time_start, 'h:mm a');
				const end = moment('11:59 p.m', 'h:mm a');

				const diff = end.diff(start, 'minutes');
				const set_duration = budgetToMinutes(this.duration);
				if (set_duration > diff) {
					is_beyond = true;
				}
			}

			return is_beyond;
		},
		isFromOmins() {
			let is_from_omins = false;

			if (this.$route.params && this.$route.params.evid) {
				is_from_omins = true;
			}
			return is_from_omins;
		},
		isJobValid() {
			let is_job_valid = true;

			if (this.job_selected && !this.job_selected.valid) {
				is_job_valid = false;
			}
			return is_job_valid;
		},
		isTaskAcOc() {
			let is_task_acoc = false;

			if (this.task_acoc === AC_Type || this.task_acoc === OC_Type) {
				is_task_acoc = true;
			}

			return is_task_acoc;
		}
	},
	async created() {
		await this.getUserId();
		await this.getSettings();
		await this.getJobStatusIds();
		await this.getTaskStatuses();
		await this.getCurrencies();
		await this.getAssignees();

		if (this.editItem) {
			this.setTimesheet(this.editItem);
		}

		if (this.job) {
			this.getJobById(this.job.id);
		}

		if (this.tasid !== 0) {
			this.getTaskById(this.tasid);
		} else {
			if (this.joid !== 0) {
				if (this.timesheet_settings) {
					if (this.timesheet_settings.job_id === this.joid) {
						if (this.timesheet_settings.task_id !== 0) {
							this.getTaskById(this.timesheet_settings.task_id);
						} else {
							this.getJobById(this.timesheet_settings.job_id, this.timesheet_settings);
						}
					} else {
						this.getJobById(this.joid);
					}
				} else {
					this.getJobById(this.joid);
				}
			} else {
				if (this.startTime.length !== 0) {
					const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
					this.timesheet_date = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'): moment().format('YYYY-MM-DD');

					if (is_valid) {
						const start_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
						this.time_start = start_time;
						this.time_start_init = this.time_start ? this.time_start : '';
					}
				}

				if (this.endTime.length !== 0) {
					const is_valid = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();

					if (is_valid) {
						const end_time = moment(this.endTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
						this.time_end = end_time;
						this.time_end_init = this.time_end ? this.time_end : '';
					}
				}

				if (this.startTime.length !== 0 && this.endTime.length !== 0) {
					const is_valid_start = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
					const is_valid_end = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();

					if (is_valid_start && is_valid_end) {
						const time1 = moment(this.startTime, 'YYYY-MM-DD HH:mm');
						const time2 = moment(this.endTime, 'YYYY-MM-DD HH:mm');
						const budget = time2.diff(time1, 'minutes');

						if (budget === 0) {
							this.duration = '';
						}
						if (budget < 0) {
							this.start_time_error = true;
						} 
						if (budget > 0) {
							this.duration = minutesToBudget(budget);
						}

						if (budget > 0) {
							this.checkDuration(false);
						}
					}
				}
			}
		}

		if (!this.editItem && !this.job && !this.tasid && !this.joid) {
			if (this.timesheet_settings) {
				if (this.timesheet_settings.task_id !== 0) {
					this.getTaskById(this.timesheet_settings.task_id);
				} else {
					if (this.timesheet_settings.job_id !== 0) {
						this.getJobById(this.timesheet_settings.job_id, this.timesheet_settings);
					}
				}
			}
		}

		this._checkAutofocusKey();
	},
	methods: {
		async getUserId() {
			this.loading = true;

			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.userId = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getSettings() {
			this.loading = true;

			const usid = this.userId;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;

							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);

								if (windata) {
									this.timesheet_settings = windata;
								}
							}
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.$store.state.user.id;
			const winname = config.win_name[`${Setting_Name}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		async getJobStatusIds() {
			this.loading = true;

			const url = '/api/jobs/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const statuses_arr = data.substatusses;
						const job_invalid_statusses = statuses_arr.filter(s => { return !config.job_status_group_nomal.includes(s.group) });
						this.job_invalid_status_ids = job_invalid_statusses.map(s => { return s.id });

						this.status_items = data.substatusses;
						this.status_items.sort((a,b) => {
							if (a.group < b.group) {
								return -1;
							} else if (a.group > b.group) {
								return 1;
							} else {
								return a.order - b.order;
							}
						});

						this.type_items = data.jobtypes;
						this.type_items.sort((a,b) => { return a.order - b.order });

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getTaskStatuses() {
			const url = '/api/tasks/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;
					
					// For some reason axios isn't always converting our data
					if (typeof(json) === "string") {
						json = JSON.parse(json);
					}

					const { status, meta, reason } = json;

					if (status == "OK") {
						this.task_statuses = meta.statusses.filter(s => { return s.isactive === true });
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) =>  {
					this.error_msg = e.message;
				});
		},
		async getCurrencies() {
			const url = '/api/expenses/receipts/meta';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.currencies = data.currencies;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async getAssignees() {
			this.loading_ts = true;

			let url = '/api/tasks/list_assignees';

			const params = [];
			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12"));

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const ts_for_arr = data[0].employees;
						ts_for_arr.forEach(t => { t.display_name = this.formatName(t.display_name) })
						this.ts_for_items = data[0].employees;
						this.for_saech_items = data[0].employees;

						if (!this.editItem) {
							if (this.user_type.includes(ATS)) {
								if (this.$store.state.user) {
									const ts_for_filter = this.ts_for_items.filter(t => { return t.id === this.$store.state.user.addressbook.id });
									this.ts_for = ts_for_filter[0];
								} else {
									this.getCurrentUser();
								}
							} else {
								if (this.adbid !== 0) {
									const ts_for_filter = this.ts_for_items.filter(t => { return t.id === this.adbid });
									this.ts_for = ts_for_filter[0];
								} else {
									if (this.$store.state.user) {
										const ts_for_filter = this.ts_for_items.filter(t => { return t.id === this.$store.state.user.addressbook.id });
										this.ts_for = ts_for_filter[0];
									} else {
										this.getCurrentUser();
									}
								}
							}
						}
						
						this.loading_ts = false;
					} else {
						this.loading_ts = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.loading_ts = false;
					this.error_msg = e.message;
				});
		},
		async getCurrentUser() {
			const url =  '/api/user/me';
				
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const addressbook = data.addressbook;
						addressbook.display_name = this.formatName(addressbook.display_name);

						this.ts_for = addressbook;						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		
		},
		async getJobById(id, timesheet_settings=null) {
			this.loading_job = true;
			
			const url = `/api/jobs/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						if (this.startTime.length !== 0) {
							const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
							this.timesheet_date = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'):moment().format('YYYY-MM-DD');
							
							if (is_valid) {
								const start_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
								this.time_start = start_time;
								this.time_start_init = this.time_start ? this.time_start : '';
							}
						}

						if (this.endTime.length !== 0) {
							const is_valid = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();

							if (is_valid) {
								const end_time = moment(this.endTime, 'YYYY-MM-DD HH:mm').format('h:mm a');
								this.time_end = end_time;
								this.time_end_init = this.time_end ? this.time_end : '';
							}
						}

						if (this.startTime.length !== 0 && this.endTime.length !== 0) {
							const is_valid_start = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
							const is_valid_end = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();

							if (is_valid_start && is_valid_end) {
								const time1 = moment(this.startTime, 'YYYY-MM-DD HH:mm');
								const time2 = moment(this.endTime, 'YYYY-MM-DD HH:mm');
								const budget = time2.diff(time1, 'minutes');

								if (budget === 0) {
									this.duration = '';
								}
								if (budget < 0) {
									this.start_time_error = true;
								} 
								if (budget > 0) {
									this.duration = minutesToBudget(budget);
								}

								if (budget > 0) {
									this.checkDuration(false);
								}
							}
						}

						this.setTimesheetByJob(data, timesheet_settings);
					} 
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_job = false
				});
		},
		async getTaskById(id, is_duration=false) {
			if (is_duration) {
				this.loading_duration = true;
			}
			const url = `/api/tasks/${id}?comments=true&worked_on=true`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;

					if (status == "OK") {
						if (is_duration) {
							const diff = data.budget - data.actual;
							this.task_left = `${diff >= 0 ? '':'- '}${minutesToBudget(Math.abs(diff))}`;
							this.task_budget = minutesToBudget(data.budget);
							this.task_actual = minutesToBudget(data.actual);
							this.task_budget_type = data.budget_type;
						} else {
							const task = {
								id: data.id,
								status_id: data.status.id,
								status: data.status.desc,
								display_name: data.description
							};
							const kind = data.kind;
							kind['display_name'] = data.kind.name;

							const phase = data.phase;
							phase['display_name'] = data.phase.name;

							const date = this.startTime.length !== 0 ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'):moment().format('YYYY-MM-DD');
							
							const timesheet_obj = {
								job: data.job,
								kind: kind,
								task: task,
								phase: data.phase,
								date: date
							};

							if (this.startTime.length !== 0) {
								const start_time = moment(this.startTime, 'YYYY-MM-DD HH:mm').format('HH:mm:ss');
								timesheet_obj['start'] = start_time;
							}
							if (this.endTime.length !== 0) {
								const end_time = moment(this.endTime, 'YYYY-MM-DD HH:mm').format('HH:mm:ss');
								timesheet_obj['stop'] = end_time;
							}
							if (this.startTime.length !== 0 && this.endTime.length !== 0) {
								const is_valid_start = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
								const is_valid_end = moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();

								if (is_valid_start && is_valid_end) {
									const time1 = moment(this.startTime, 'YYYY-MM-DD HH:mm');
									const time2 = moment(this.endTime, 'YYYY-MM-DD HH:mm');
									const budget = time2.diff(time1, 'minutes');

									if (budget === 0) {
										timesheet_obj['duration'] = 0;
									}
									if (budget < 0) {
										this.start_time_error = true;
									} 
									if (budget > 0) {
										timesheet_obj['duration'] = budget;
									}

									
									if (budget > 0) {
										/** init timesheet_date for checkDuration calculation */
										const is_valid = moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid();
										this.timesheet_date = is_valid ? moment(this.startTime, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DD'):moment().format('YYYY-MM-DD');

										this.checkDuration(false, budget);
									}
								}
							}

							this.timesheet_by_id = timesheet_obj;
							this.setTimesheet(timesheet_obj);
						}

						this.ac_oc = data.acoc !== AC_Type && data.acoc !== OC_Type ? 0 : data.acoc;
						this.task_acoc = data.acoc;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading_duration = false;
				})
				.finally(() => {
					this.loading_duration = false;
				});
		},
		getAbookJson(adbid) {
			const url = `/api/addressbook/${adbid}/no_priv_check`;

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});
		},
		getActualsQuoted(phase_id, kind_id, currency_id, task_id=0) {				
			const params = [];
			params.push("phase_id=" + phase_id);
			params.push("kind_id=" + kind_id);
			params.push('curr_id' + '=' + currency_id);
			if (task_id !== 0) {
				params.push("task_id=" + task_id);
			}

			let url = "/api/jobs/actuals_quoted";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const diff = data.quoted.minutes - data.actuals.minutes;
						this.task_left = `${diff >= 0 ? '':'- '}${minutesToBudget(Math.abs(diff))}`;
						this.task_budget = minutesToBudget(data.quoted.minutes);
						this.task_actual = minutesToBudget(data.actuals.minutes);

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		async setTimesheetByJob(job, timesheet_settings=null) {
			const desc = job.description.length > DescriptionLimit ? job.description.slice(0, DescriptionLimit) + '...': job.description;
			job['display_name'] = `${job.code} - ${desc}`;

			const is_valid = this.completedJobPrivilege ? !this.job_invalid_status_ids.includes(job.status.id) :true;
			job['valid'] = is_valid;

			const overhead = job.is_overhead || job.job_type.overhead_mode === 1 || job.job_type.code === 'OVER';
			job['overhead'] = overhead;

			this.job_items.push(job);
			this.job_selected = job;

			this._initTaskAndPhase();
			await this._getPhaseForJob(job, null, timesheet_settings);
			await this._getTaskGroupByPhase(job, this.ts_for.id, null, timesheet_settings);
		},
		async setTimesheet(timesheet) {
			this.loading_job = true;
			const id = timesheet.job.id;
			const url = `/api/jobs/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						if (timesheet.address_book) {
							const addressbook = timesheet.address_book;
							addressbook.display_name = this.formatName(addressbook.display_name);
							this.ts_for = addressbook;
							this.ts_type = timesheet.is_freelance ? Freelancer_Type : Employee_Type;
						}
						timesheet.job['client'] = data.client;

						const desc = data.description.length > DescriptionLimit ? data.description.slice(0, DescriptionLimit) + '...': data.description;
						data['display_name'] = `${data.code} - ${desc}`;

						const is_valid = this.completedJobPrivilege ? !this.job_invalid_status_ids.includes(data.status.id) :true;
						data['valid'] = is_valid;

						this.job_items.push(data);
						this.job_selected = data;

						this._initTaskAndPhase();
						this._getPhaseForJob(this.job_selected, timesheet);
						this._getTaskGroupByPhase(this.job_selected, this.ts_for.id, timesheet);
							
						if (timesheet.kind) {
							this.kind = timesheet.kind;
							this.kind_selected = timesheet.kind;
						}						

						const overhead = data.is_overhead || data.job_type.overhead_mode === 1 || data.job_type.code === 'OVER';
						this.item_params.overhead_mode = overhead ? Overhead_Mode : Any_Mode;
						this.kind_params.overhead_mode = overhead ? 2 : 1;
						
						
						this.timesheet_date = moment(timesheet.date).format('YYYY-MM-DD');
						this.duration = minutesToBudget(timesheet.duration);
						this.time_start = timesheet.start ? moment(timesheet.start, 'HH:mm:ss').format('h:mm a') : null;
						this.time_end = timesheet.stop ? moment(timesheet.stop, 'HH:mm:ss').format('h:mm a') : null,
						this.time_start_init = this.time_start ? this.time_start : '';
						this.time_end_init = this.time_end ? this.time_end : '';

						if (timesheet.start && timesheet.start.length !== 0 && timesheet.stop && timesheet.stop.length !== 0) {
							this.checkDuration(this.editItem && !this.isAddTimesheet_local ? true: false);
						}

						this.notes = timesheet.notes;
						this.ac_oc = timesheet.acoc;

						this.loading_job = false;
					} else {
						this.error_msg = reason;
						this.loading_job = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading_job = false;
				});
			
		},
		async load_client_meta() {
			this.loading = true;

			const types = '1,14'; // 1=client, 14=prospects
			const params = [];
			params.push("abook_types=" + encodeURIComponent(types));

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data, reason } = json;

					if (status == "OK") {
						this.client_items = data;
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		removeClient (item) {
			this.job_client = this.job_client.filter(client => { return client.id !== item.id });
		},
		removeStatus (item) {
			this.job_status = this.job_status.filter(client => { return client.id !== item.id });
		},
		removeTypes (item) {
			this.job_type = this.job_type.filter(client => { return client.id !== item.id });
		},
		onBack() {
			if (!this.search_flag && this.search_more) {
				this.search_more = false;
				this.search_flag = false;
			}

			if (this.search_flag && this.search_more) {
				this.job_items = [];
				this.job_client = [];
				this.job_status = [];
				this.job_type = [];
				this.search_flag = false;
			}
		},
		onSearchMore() {
			if (this.editItem && (!this.amendTimesheetPrivilege || !isJobValid)) return;

			this.search_more = !this.search_more;

			if (this.search_more) {
				this.load_client_meta();
			}
		},
		onForSaechChange(key) {
			const lowercase_key = key.toLowerCase();

			this.for_saech_items = this.ts_for_items.filter(item => { 
				const name = item.display_name.toLowerCase();
				return name.includes(lowercase_key)
			});
		},
		onForSaechClick(item) {
			this.ts_for = item;
			this.menu = false;

			if (this.job_selected && this.job_selected.id !== 0 && this.editItem) {
				this._initTaskAndPhase();
				this._getPhaseForJob(this.job_selected);
				this._getTaskGroupByPhase(this.job_selected, this.ts_for.id);
			}

			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onJobSearch() {
			this.loading = true;

			const params = [];
			if (this.job_client.length !== 0) {
				const client_param = this.job_client.map(client => { return client.id});
				params.push("client=" + encodeURIComponent(client_param));

			}
			if (this.job_status.length !== 0) {
				const statusses_param = this.job_status.map(status => status.id);
				params.push("statusses=" + encodeURIComponent(statusses_param));
			}
			if (this.job_type.length !== 0) {
				const type_param = this.job_type.map(type => type.id);
				params.push("job_types=" + encodeURIComponent(type_param));
			}

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						if (this.completedJobPrivilege) {
							const data_tmp = data.filter(d => { return !this.job_invalid_status_ids.includes(d.status.id) });
							this.job_items = data_tmp.map(d => {
								const obj = d;
								obj['res_code'] = d.code;
								obj['res_short'] = d.short;
								obj['res_type'] = d.job_type.name;
								obj['res_status'] = d.status.name;
								obj['valid'] = true;
								return obj;
							});
						} else {
							this.job_items = data.map(d => {
								const obj = d;
								obj['res_code'] = d.code;
								obj['res_short'] = d.short;
								obj['res_type'] = d.job_type.name;
								obj['res_status'] = d.status.name;
								obj['valid'] = true;
								return obj;
							});
						}

						this.search_flag = true;

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		jobQuery(key) {
			this.loading_job = true;
			const params = [];
			params.push("code_and_name=" + encodeURIComponent(key));

			let url = "/api/jobs";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						let data_filter = data;

						/** not display dead, complete or cancelled jobs in the list, if Restrict entry privilege is disabled  */
						/** display the dead complete or cancelled jobs in the list(can be selected), if Restrict entry privilege is enabled */

						if (this.completedJobPrivilege) {
							data_filter = data.filter(d => { return !this.job_invalid_status_ids.includes(d.status.id)})
						}

						const code_data = data_filter.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return code_lowercase.includes(key_lowercase);
						});
						
						const desc_data = data_filter.filter(d => { 
							const code_lowercase = d.code.toLowerCase();
							const key_lowercase = key.toLowerCase();
							return !code_lowercase.includes(key_lowercase);
						});

						data_filter = [...code_data, ...desc_data];
						
						this.job_items = data_filter.map(d => {
							const description = d.display_name.length > DescriptionLimit
								? d.display_name.slice(0, DescriptionLimit) + '...'
								: d.display_name;
							
							let is_disabled = false;
							if (this.completedJobPrivilege) {
								is_disabled = this.job_invalid_status_ids.includes(d.status.id) ? true : false;
							}

							const obj = {
								id: d.id,
								display_name: description,
								acc_dir: d.acc_dir,
								acc_exec: d.acc_exec,
								job_type: d.job_type,
								currency_id: d.currency.id,
								currency: d.currency,
								disabled: false,
								client: d.client,
								valid: !is_disabled
							};

							return obj;
						});

					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_job = false
				});
		},
		onJobSelected(job, is_from_more_search=false) {
			this.search_flag = false;
			this.search_more = false;
			this.error_job_flag = false;

			if (is_from_more_search) {
				this.job_selected = job;
			}

			this._initTaskAndPhase();

			if (job) {
				this._getPhaseForJob(job);
				this._getTaskGroupByPhase(job, this.ts_for.id);
			}
		},
		_initTaskAndPhase() {
			this.warn_msg = '';

			this.error_job_flag = false;
			this.error_phase_flag = false;
			this.error_task_name_flag = false;
			this.error_task_status_flag = false;
			this.error_kind_flag = false;
			this.error_limit_kind_flag = false;

			this.is_only_phase = false;
			this.is_second_step_phase = false;
			this.phase = null;
			this.phase_items = [];

			this.task = null;
			this.task_items = [];

			this.task_status = null;

			this.task_left = '0m';
			this.task_budget = '0m';
			this.task_actual = '0m';

			this.item_params.overhead_mode = 0;
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		async _getTaskGroupByPhase(job, adbid, timesheet=null, timesheet_settings=null) {
			const overhead = job.is_overhead || job.job_type.overhead_mode === 1 || job.job_type.code === 'OVER';
			this.item_params.overhead_mode = overhead ? Overhead_Mode : Any_Mode;
			this.kind_params.overhead_mode = overhead ? 2 : 1;

			if (this.limitKindsPrivilege) {
				this.kind_params['allowed_on_abook'] = job.client.id;
				this.kind_params['accepted_on_job'] = job.id;
				this.kind_params['traffic_on_job'] = job.id;
				this.kind_params['traffic_only'] = false;
			}

			this.loading_phase_task = true;
	
			let url = `/api/jobs/${job.id}/assigned_tasks`;
	
			const params = [];
			params.push("employeeid=" + adbid);

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
	
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;
	
					// For some reason axios isn't always converting our data
					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
	
					const { status, data, reason } = json;
	
					if (status == "OK") {
						if ((data.length === 0 && this.tasid === 0)) {
							this.is_only_phase = true;

							if (timesheet_settings && timesheet_settings.task_id === 0) {	
								this.kind_selected = timesheet_settings.kind;
								this.kind = timesheet_settings.kind;
							}
														
						} else if (data.length === 0 && this.tasid !== 0 && !timesheet) {
							this.is_only_phase = true;

						} else if (data.length === 0 && (this.tasid !== 0 || this.editItem) && timesheet && timesheet.task) {
							let task_list_tmp = [];

							const task_obj = {
								id: timesheet.task.id,
								description: timesheet.task.display_name,
								kind: {
									id: timesheet.kind.id,
									desc: timesheet.kind.display_name,
									code: timesheet.kind.code,
								},
								phase: {
									id: timesheet.phase.id,
									name: timesheet.phase.display_name
								},
								status: {
									id: timesheet.task.status_id,
									name: timesheet.task.status,
								},
								task_name: timesheet.task.display_name,
							};

							task_list_tmp.push(task_obj);
							task_list_tmp.unshift(No_Related_Task);

							this.task_items = task_list_tmp;
							this.task = task_obj;
							this.task_status = (this.task_statuses.filter(t => { return t.id === timesheet.task.status_id }))[0];

						} else {
							const data_department = data.filter(d => { return d.employee_id === null});
							const data_employee = data.filter(d => { return d.employee_id !== null});
							data_employee.sort((a, b) => {
								const a_moment = moment(a.timestamp).format('YYYY-MM-DD-HH-mm-ss');
								const b_moment = moment(b.timestamp).format('YYYY-MM-DD-HH-mm-ss');

								if (a_moment > b_moment) {
									return -1;
								}
								if (a_moment < b_moment) {
									return 1;
								}

								return 0;
							});

							const data_order = [...data_employee, ...data_department];

							let phase_arr_tmp = [];
							data_order.forEach(task => {
								const not_exist = phase_arr_tmp.every(phase => { return phase.id !== task.phase.id});
								if (not_exist) {
									phase_arr_tmp.push(task.phase)
								}
							});

							phase_arr_tmp.forEach(phase => {
								phase['desc'] = phase.name;
								phase['completed'] = phase.status === Completed_Phase ? true : false; 							
							});

							if (!this.completedPhasePrivilege) {
								phase_arr_tmp = phase_arr_tmp.filter(p => { return p.completed === false });
							}

							
							let task_list_tmp = [];
							phase_arr_tmp.forEach(phase => {
								const task_group_tmp = data_order.filter(task => { return task.phase.id === phase.id });
								task_group_tmp.forEach(task => { task['description'] = task.task_name} ) 
								
								const parent_obj = {
									id: phase.id,
									description: phase.name,
									parent: null
								};
								task_group_tmp.unshift(parent_obj);
	
								task_list_tmp = [...task_list_tmp, ...task_group_tmp];
							});
	
							task_list_tmp.unshift(No_Related_Task);
							this.task_items = task_list_tmp;

							if (!timesheet) {
								if (timesheet_settings && timesheet_settings.task_id === 0) {
									this.task = No_Related_Task;
									this.phase = this.phase_items[0];
									this.is_second_step_phase = true;
													
									this.task_status = null;

									this.kind_selected = timesheet_settings.kind;
									this.kind = timesheet_settings.kind;
								} else {
									const task_filter = task_list_tmp.filter(t => { return t.id !== 0 && t.task_name && t.task_name.length !== 0 && t.kind });
									const task_tmp = task_filter[0];

									const task_obj = {
										id: task_tmp.id,
										description: task_tmp.description,
										kind: {
											id: task_tmp.kind.id,
											desc: task_tmp.kind.desc,
											code: task_tmp.kind.code,
										},
										phase: {
											id: task_tmp.phase.id,
											name: task_tmp.phase.name
										},
										status: {
											id: task_tmp.status.id,
											name: task_tmp.status.name,
										},
										task_name: task_tmp.task_name,
									};

									this.task = task_obj;
									this.task_status = (this.task_statuses.filter(t => { return t.id === this.task.status.id }))[0];
									this.onTaskChange(task_obj);
								}
							}

							if (timesheet) {
								if (this.tasid !== 0) {
									const existed_task_arr = this.task_items.filter(t => { return t.id === this.tasid });
									
									if (existed_task_arr.length !== 0) {
										this.task = existed_task_arr[0];
										this.task_status = (this.task_statuses.filter(t => { return t.id === timesheet.task.status_id }))[0];
									} else {
										const task_obj = {
											id: timesheet.task.id,
											description: timesheet.task.display_name,
											kind: {
												id: timesheet.kind.id,
												desc: timesheet.kind.display_name,
												code: timesheet.kind.code,
											},
											phase: {
												id: timesheet.phase.id,
												name: timesheet.phase.display_name
											},
											status: {
												id: timesheet.task.status_id,
												name: timesheet.task.status,
											},
											task_name: timesheet.task.display_name,
										};
										const index = this.task_items.findIndex(item => { return item.id === task_obj.phase.id && !item.parent });
										this.task_items.splice(index+1, 0, task_obj);
										this.task = task_obj;
										this.task_status = (this.task_statuses.filter(t => { return t.id === timesheet.task.status_id }))[0];
									}
								} else {
									if (timesheet.task) {
										const existed_task_arr = this.task_items.filter(t => { return t.id === timesheet.task.id });

										if (existed_task_arr.length !== 0) {
											this.task = existed_task_arr[0];
											this.task_status = (this.task_statuses.filter(t => { return t.id === timesheet.task.status_id }))[0];
										} else {										
											const task_obj = {
												id: timesheet.task.id,
												description: timesheet.task.display_name,
												kind: {
													id: timesheet.kind.id,
													desc: timesheet.kind.display_name,
													code: timesheet.kind.code,
												},
												phase: {
													id: timesheet.phase.id,
													name: timesheet.phase.display_name
												},
												status: {
													id: timesheet.task.status_id,
													name: timesheet.task.status,
												},
												task_name: timesheet.task.display_name,
											};

											const index = this.task_items.findIndex(item => { return item.id === task_obj.phase.id && !item.parent });
											this.task_items.splice(index+1, 0, task_obj);
											this.task = task_obj;
											this.task_status = (this.task_statuses.filter(t => { return t.id === timesheet.task.status_id }))[0];
										}
									} else {
										this.task = No_Related_Task;
										this.phase = this.phase_items[0];
										this.is_second_step_phase = true;
													
										this.task_status = null;
									}
								}
							}

							if (this.task && this.task.id !== 0) {
								this.getTaskById(this.task.id, true);
							}
						}

						if (this.kind && this.kind.id !== 0 && this.phase && this.phase.id && this.job_selected && this.job_selected.id !== 0) {
							const task_id = this.task && this.task.id !== 0 ? this.task.id : 0;
							if (task_id === 0) {
								this.getActualsQuoted(this.phase.id, this.kind.id, this.job_selected.currency.id, task_id);
							}
						}
				
						this._checkAutofocusKey();
						this.isActive = this._isActiveCreateTimesheet();						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_phase_task = false;
				});
		},
		async _getPhaseForJob(job, timesheet=null, timesheet_settings=null) {
			this.loading_phase_task = true;

			const url = `/api/jobs/${job.id}/phases`;
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;

					if (status == "OK") {
						data.sort((a, b) => a.id - b.id);

						data.forEach(d => {
							d['completed'] = d.status === Completed_Phase ? true : false;
						});

						const phase_list_tmp = [];

						data.forEach(phase => {
							if (this.completedPhasePrivilege) {
								phase['desc'] = phase.display_name;
								phase_list_tmp.push(phase);
							} else {
								if (!phase.completed) {
									phase['desc'] = phase.display_name;
									phase_list_tmp.push(phase);
								}
							}
						});

						this.phase_items = phase_list_tmp;
						if (timesheet) {
							const existed_phase_arr = this.phase_items.filter(p => { return p.id === timesheet.phase.id });
							this.phase = existed_phase_arr[0];
						} else if (timesheet_settings) {
							const existed_phase_arr = this.phase_items.filter(p => { return p.id === timesheet_settings.phase_id });
							if (existed_phase_arr.length !== 0) {
								this.phase = existed_phase_arr[0];
							} else {
								this.phase = this.phase_items[0];
							}
						} else {
							this.phase = this.phase_items[0];
						}

						if (this.editItem) {
							this.kind = this.editItem.kind;
							this.kind_selected = this.editItem.kind;
						}

						this._checkAutofocusKey();
						this.isActive = this._isActiveCreateTimesheet();						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_phase_task = false;
				});
		},
		onTsForChange() {
			if (this.job_selected && this.job_selected.id !== 0) {
				if (this.tasid !== 0) {
					this._initTaskAndPhase();
					this._getPhaseForJob(this.job_selected);

					const timesheet = this.timesheet_by_id.job.id === this.job_selected.id ? this.timesheet_by_id : null;
					this._getTaskGroupByPhase(this.job_selected, this.ts_for.id, timesheet);
					
				} else {
					this._initTaskAndPhase();
					this._getPhaseForJob(this.job_selected);
					this._getTaskGroupByPhase(this.job_selected, this.ts_for.id);
				}
			}
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onTypeChange() {
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onPhaseChange() {
			this.error_phase_flag = false;

			this.task_left = '0m';
			this.task_budget = '0m';
			this.task_actual = '0m';

			if (this.kind && this.kind.id !== 0 && this.phase && this.phase.id && this.job_selected && this.job_selected.id !== 0) {
				const task_id = this.task && this.task.id !== 0 ? this.task.id : 0;
				if (task_id === 0) {
					this.getActualsQuoted(this.phase.id, this.kind.id, this.job_selected.currency.id, task_id);
				}
			}

			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onTaskChange(task) {
			this.error_task_name_flag = false;
			this.error_task_status_flag = false;

			if (task.id !== 0) {
				this.error_kind_flag = false;
				this.error_limit_kind_flag = false;
			}

			if (task && task.id !== 0) {
				this.is_second_step_phase = false;
				this.task_status = this._lowerCase(task.status);
				
				let kind_obj = {
					id: 0,
					display_name: ''
				};
				if (task.kind) {
					kind_obj['id'] = task.kind.id;
					kind_obj['display_name'] = task.kind.desc;
				}

				this.kind = kind_obj;
				this.kind_selected = kind_obj;
				if (task.id !== 0) {
					this.getTaskById(task.id, true);
				}
			}

			if (task && task.id === 0) {
				this.phase = this.phase_items[0];
				this.is_second_step_phase = true;
				this.task_status = null;

				const kind_obj = {
					id: 0,
					display_name: ''
				};
				this.kind = kind_obj;
				this.kind_selected = kind_obj;

				this.task_left = '0m';
				this.task_budget = '0m';
				this.task_actual = '0m';
			}
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onNoData(is_no_data) {
			if (this.limitKindsPrivilege && is_no_data) {
				this.warn_msg = Warning_Note;
			}
		},
		onKindChange(kind) {
			this.error_kind_flag = false;
			this.error_limit_kind_flag = false;
			this.error_task_name_flag = false;
			this.error_task_status_flag = false;

			if (this.job_selected && this.job_selected.id === 0) {
				this.error_job_flag = true;
			}

			if (this.phase_items.length !== 0 && !this.phase) {
				this.error_phase_flag = true;
			}
			
			if (kind && kind.id !== 0) {
				this.task = No_Related_Task;
				if (this.task_items.length === 0) {
					this.task_items = [No_Related_Task];
				}
				this.task_status = null;
				this.is_second_step_phase = true;

				this.kind = kind;
			}

			if (kind === null) {
				this.kind = { id: 0, display_name: '' };
			}
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onTaskStatusChange() {
			this.error_task_status_flag = false;

			if (this.job_selected && this.job_selected.id === 0) {
				this.error_job_flag = true;
			}
			if (this.phase_items.length !== 0 && !this.phase) {
				this.error_phase_flag = true;
			}
			if (this.kind && this.kind.id === 0) {
				if (!this.task) {
					this.error_task_name_flag = true;
				}
			}
			if (!this.task || (this.task && this.task.id === 0) || (this.task && this.task.id !== 0 && this.task.kind === null)) {
				if (!this.kind || this.kind && this.kind.id === 0) {
					this.error_kind_flag = true;
				}
			}
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onDateChange(date) {
			this.error_date_flag = false;
			if (this.job_selected && this.job_selected.id === 0) {
				this.error_job_flag = true;
			}
			if (this.phase_items.length !== 0 && !this.phase) {
				this.error_phase_flag = true;
			}
			if (this.kind && this.kind.id === 0) {
				if (!this.task) {
					this.error_task_name_flag = true;
				}
				if (this.task && this.task.id !== 0 && !this.task_status) {
					this.error_task_status_flag = true;
				}
			}

			this.timesheet_date = date === null ? '' : date;
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onDurationChange(duration) {
			this.checkError();

			if (validHour(duration)) {
				const duration_minute = budgetToMinutes(duration);
				this.duration = minutesToBudget(duration_minute);

				if (duration_minute > 0) {
					this.checkDuration(this.editItem && !this.isAddTimesheet_local ? true: false);
				}
			}

			this.isActive = this._isActiveCreateTimesheet();
		},
		onTimeStartChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_start = time;

			this.checkError();
			this.onDuration(true);
			this.isActive = this._isActiveCreateTimesheet();
		},
		onTimeEndChange(time) {
			this.start_time_error = false;
			this.end_time_error = false;

			this.time_end = time;

			this.checkError();
			this.onDuration(false);
			this.isActive = this._isActiveCreateTimesheet();
		},
		checkError() {
			this.start_time_error = false;
			this.end_time_error = false;
			this.error_start_flag = false;
			this.error_end_flag = false;
			this.error_duration_flag = false;
			this.error_duration_over_flag = false;

			if (this.job_selected && this.job_selected.id === 0) {
				this.error_job_flag = true;
			}

			if (this.phase_items.length !== 0 && !this.phase) {
				this.error_phase_flag = true;
			}

			if (this.kind && this.kind.id === 0) {
				if (!this.task) {
					this.error_task_name_flag = true;
				}
				if (this.task && this.task.id !== 0 && !this.task_status) {
					this.error_task_status_flag = true;
				}
			}

			if (!this.task || (this.task && this.task.id === 0)|| (this.task && this.task.id !== 0 && this.task.kind === null)) {
				if (this.kind && this.kind.id === 0) {
					this.error_kind_flag = true;
				}
			}

			if (this.timesheet_date.length === 0) {
				this.error_date_flag = true;
			}
		},
		onDuration(is_start=true) {
			const time_start = this.time_start ? this.time_start: '0';
			let time_start_tmp = time_start.replace(/\s+/g,"");

			const time_end = this.time_end ? this.time_end : '0';
			let time_end_tmp = time_end.replace(/\s+/g,"");

			if (validTime(time_start_tmp) && validTime(time_end_tmp)) {
				const time1 = moment(time_start_tmp, 'HH:mma');
				const time2 = moment(time_end_tmp, 'HH:mma');
				const budget = time2.diff(time1, 'minutes');

				if (budget === 0) {
					this.duration = '';
				}
				if (budget < 0) {
					if (is_start) {
						this.start_time_error = true;
					} else {
						this.end_time_error = true;
					}
				} 
				if (budget > 0) {
					this.duration = minutesToBudget(budget);
				}

				if (time_start !== '0' && time_end !== '0' && budget > 0) {
					this.checkDuration(this.editItem && !this.isAddTimesheet_local ? true: false);
				}
			}
		},
		checkDurationUnactive() {
			if (!this.isActive) {
				if (this.job_selected && this.job_selected.id === 0) {
					this.error_job_flag = true;
				}
				if (this.phase_items.length !== 0 && !this.phase) {
					this.error_phase_flag = true;
				}
				if (this.kind && this.kind.id === 0) {
					if (!this.task) {
						this.error_task_name_flag = true;
					}
					if (this.task && this.task.id !== 0 && !this.task_status) {
						this.error_task_status_flag = true;
					}
				}

				if (!this.task || (this.task && this.task.id === 0) || (this.task && this.task.id !== 0 && this.task.kind === null)) {
					if (!this.kind || (this.kind && this.kind.id === 0)) {
						this.error_kind_flag = true;
					}
				}

				if (this.timesheet_date.length === 0) {
					this.error_date_flag = true;
				}

				if (!this.duration || this.duration.length === 0 || !validHour(this.duration)) {
					this.error_duration_flag = true;
					if (!this.time_start || (this.time_start && this.time_start.length === 0)) {
						this.error_start_flag = true;
					}
					if (!this.time_end || (this.time_end && this.time_end.length === 0)) {
						this.error_end_flag = true;
					}
				}
				
				return;
			}
		},
		checkDuration(isUpgrate, minutes=0) {
			/** new logic, only check the start time field and end time field, if not empty, 24h limit */

			/** clone or duplicate a timesheet with start and stop */
			// const situation_a = this.editItem && this.isAddTimesheet && this.editItem.start && this.editItem.start.length !== 0 && this.editItem.stop && this.editItem.stop.length !== 0;
			const situation_a = this.editItem && this.isAddTimesheet && this.editItem.start && this.editItem.start.length !== 0 && this.editItem.stop && this.editItem.stop.length !== 0 && this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0;
			
			/** pre-fill start/end time from desktop */
			// const situation_b = this.startTime.length !== 0 && this.endTime.length !== 0 && moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid() && moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid();
			const situation_b = this.startTime.length !== 0 && this.endTime.length !== 0 && moment(this.startTime, 'YYYY-MM-DD HH:mm').isValid() && moment(this.endTime, 'YYYY-MM-DD HH:mm').isValid() && this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0;
			
			if (situation_a || situation_b) {
				const params = [];

				let adbid = 0;
				if (this.user_type.includes(ATS)) {
					adbid = this.user_abid;
				} else {
					adbid = this.adbid !== 0 ? this.adbid : (this.ts_for ? this.ts_for.id : this.user_abid);
				}

				params.push("employees=" + adbid);
				params.push("start_date=" + this.timesheet_date);
				params.push("end_date=" + this.timesheet_date);

				let url = "/api/timesheets";
				if (params.length > 0) {
					url+= "?" + params.join('&');
				}

				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						let json = val.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						const { status, data, reason } = json;

						if (status == "OK") {
							let existed_minutes = 0;
							if (isUpgrate) {
								const data_filter = data.filter(d => { return d.id !== this.editItem.id });
								data_filter.forEach(d => {
									existed_minutes += d.duration;
								});
							} else {
								data.forEach(d => {
									existed_minutes += d.duration;
								});
							}

							let minutes_current = minutes !== 0 ? minutes : budgetToMinutes(this.duration);

							if (minutes_current + existed_minutes > 24 * 60) {
								this.error_duration_over_flag = true;
							} else {
								this.error_duration_over_flag = false;
							}

							this.isActive = this._isActiveCreateTimesheet();
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			}
		},
		async checkType(isUpgrate) {
			if (isUpgrate) {
				this.onUpdateTimeSheet();
			} else {
				this.onCreateTimeSheet();
			}			
		},
		onDescriptionChange() {
			this.error_start_flag = false;
			this.error_end_flag = false;
			this.error_duration_flag = false;

			if (this.job_selected && this.job_selected.id === 0) {
				this.error_job_flag = true;
			}
			if (this.phase_items.length !== 0 && !this.phase) {
				this.error_phase_flag = true;
			}
			if (this.kind && this.kind.id === 0) {
				if (!this.task) {
					this.error_task_name_flag = true;
				}
				if (this.task && this.task.id !== 0 && !this.task_status) {
					this.error_task_status_flag = true;
				}
			}

			if (!this.task || (this.task && this.task.id === 0) || (this.task && this.task.id !== 0 && this.task.kind === null)) {
				if (!this.kind || (this.kind && this.kind.id === 0)) {
					this.error_kind_flag = true;
				}
			}

			if (this.timesheet_date.length === 0) {
				this.error_date_flag = true;
			}
			this.isActive = this._isActiveCreateTimesheet();
		},
		onItemsChange(items) {
			this.items = items;
			this.isActive = this._isActiveCreateTimesheet();
		},
		onKeydown(event) {
			/** 
			 * case 1, 'Enter' in numpad => submit
			 * case 2, 'Return' => submit
			 */
			if (event.keyCode === Keydown_Key) {
				this.isActive = this._isActiveCreateTimesheet();

				if (this.isActive) {
					const is_update = this.editItem && !this.isAddTimesheet_local ? true: false;
					this.checkType(is_update);
				}
			}
		},
		onKeydownDesc(event) {
			/** 
			 * case 1, 'Enter' in number pad => submit
			 * case 2, 'return' => add a new line 
			 * case 1, 'shift'+'return' => submit
			 */
			const case2 = event.keyCode === Keydown_Key && event.shiftKey;
			const case3 = event.keyCode === Keydown_Key && event.code === Keydown_Code_Num;
			if (case2 || case3) {
				this.isActive = this._isActiveCreateTimesheet();

				if (this.isActive) {
					const is_update = this.editItem && !this.isAddTimesheet_local ? true: false;
					this.checkType(is_update);
				}
			}
		},
		onCreateTimeSheet() {
			if (this.button_click_flag) return;
			if (!this.isValidDurationForSave()) {
				this.error_duration_flag = true;
				this._checkAutofocusKey();
				this.isActive = false;
				return;
			}
			this.button_click_flag = true;
				
			const url = "/api/timesheets";

			const params = {};
			params['acoc'] = this.ac_oc !== AC_Type && this.ac_oc !== OC_Type ? 0 : this.ac_oc;
			params['date'] = moment(this.timesheet_date).format('YYYYMMDD');
			params['duration'] = budgetToMinutes(this.duration);
			params['notes'] = this.notes;

			const phase_id = this.task && this.task.id !== 0 ? this.task.phase.id : this.phase.id;
			params['phase_id'] = phase_id;
			
			if (this.task && this.task.id !== 0 && this.task.kind !== null) {
				params['task_id'] = this.task.id;
				params['task_status_id'] = this.task_status.id;
			} else {
				params['kind_id'] = this.kind.id;
			}

			if (this.time_start && this.time_end) {
				params['start_time'] = moment(this.time_start, 'h:mm a').format('HH:mm:ss');
				params['end_time'] = 	moment(this.time_end, 'h:mm a').format('HH:mm:ss');
			}

			if (!this.restrictedPrivilege) {
				if (this.ts_for) {
					params['employee_id'] = this.ts_for.id;
				}
			}

			if (this.ts_type === Freelancer_Type) {
				params['is_external'] = true;
			}

			axios
				.post(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						const task_id = params['task_id'] ? params['task_id'] : 0;
						const win_setup_str = this._setWinSetup(this.job_selected.id, task_id, phase_id, this.kind.id, this.kind.display_name);
						this.updateSettings(win_setup_str)
							.then(() => {
							})
							.catch((reason) => {
								this.error_msg = reason;
							});

						if (this.items.length === 0) {
							this._close();
						} else {
							this.onCreateItems();
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		onUpdateTimeSheet() {
			if (this.button_click_flag) return;
			if (!this.isValidDurationForSave()) {
				this.error_duration_flag = true;
				this._checkAutofocusKey();
				this.isActive = false;
				return;
			}
			this.button_click_flag = true;

			const url = `/api/timesheets/${this.editItem.id}`;

			const params = {};
			params['acoc'] = this.ac_oc !== AC_Type && this.ac_oc !== OC_Type ? 0 : this.ac_oc;
			params['date'] = moment(this.timesheet_date).format('YYYYMMDD');
			params['duration'] = budgetToMinutes(this.duration);
			params['notes'] = this.notes;

			const phase_id = this.task && this.task.id !== 0 ? this.task.phase.id : this.phase.id;
			params['phase_id'] = phase_id;

			if (this.task && this.task.id !== 0 && this.task.kind !== null) {
				const task_tmp = this._lowerCase(this.task);
				params['task_id'] = task_tmp.id;
				params['task_status_id'] = this.task_status.id;

				const kind_tmp = this._lowerCase(this.kind);
				params['kind_id'] = kind_tmp.id;
			} else {
				const kind_tmp = this._lowerCase(this.kind);
				params['kind_id'] = kind_tmp.id;
			}

			if (this.time_start && this.time_end) {
				params['start_time'] = moment(this.time_start, 'h:mm a').format('HH:mm:ss');
				params['end_time'] = 	moment(this.time_end, 'h:mm a').format('HH:mm:ss');
			}

			if (!this.restrictedPrivilege) {
				if (this.ts_for) {
					params['employee_id'] = this.ts_for.id;
				}
			}

			if (this.ts_type === Freelancer_Type) {
				params['is_external'] = true;
			}
			if (this.ts_type === Employee_Type) {
				params['is_external'] = false;
			}
			
			axios
				.put(url, params, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, reason } = json;

					if (status == "OK") {
						if (this.items.length === 0) {
							this._close();
						} else {
							this.onCreateItems();
						}
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.button_click_flag = false;
				});
		},
		onCopyTimesheet() {
			if (this.editItem && !this.amendTimesheetPrivilege) return;

			this.isAddTimesheet_local = true;
			this._checkAutofocusKey();
			this.isActive = this._isActiveCreateTimesheet();
		},
		onDeleteTimesheet() {
			if (this.editItem && !this.amendTimesheetPrivilege) return;

			this.delete_visible = true;
		},
		onDelete() {
			const url = `/api/timesheets/${this.editItem.id}`;

			axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;
						const title = this.editItem.task ? this.editItem.task.display_name : this.editItem.kind.display_name;

						this.notice_text.push(`Timesheet ‘(${title})’ has been deleted successfully.`);
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				});
		},
		onEditTimesheetClose() {
			if (this.isActive) {
				this.unsaved_visible = true;
			} else {
				this.$emit('cancel-timesheet');
			}
		},
		onCreateItems() {
			const params_arr = [];
			for (let index = 0; index < this.items.length; index++) {
				const element = this.items[index];
				
				if (element.kind !== null && element.units !== 0) {
					const params = {};
					params['date'] = moment(this.timesheet_date).format('YYYYMMDD');
					params['units'] = element.units;

					const phase_id = this.task && this.task.id !== 0 ? this.task.phase.id : this.phase.id;
					params['phase_id'] = phase_id;

					params['kind_id'] = element.kind.id;
					params['currency_id'] = element.currency.id;
					params['item_value'] = element.charge_rate * element.units;

					if (element.notes && element.notes.length !== 0) {
						params['notes'] = element.notes;
					}

					params_arr.push(params)
				}
			}

			if (params_arr.length !== 0) {
				const url = params_arr.length === 1 ? '/api/items' : '/api/items/multipleitems';
				const params_req = params_arr.length === 1 ? params_arr[0] : { items : params_arr };

				axios
					.post(url, params_req, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						let json = val.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						const { status, reason } = json;

						if (status == "OK") {
							this._close();
						} else {
							this.error_msg = reason;
						}
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			} else {
				this._close();
			}
		},
		isValidDurationForSave() {
			return this.duration !== null
				&& this.duration !== undefined
				&& String(this.duration).length !== 0
				&& validHour(this.duration)
				&& budgetToMinutes(this.duration) > 0;
		},
		_isActiveCreateTimesheet() {
			let isActive = false;			

			let valid_count = 0;
			if (this.items.length !== 0) {
				for (let index = 0; index < this.items.length; index++) {
					const item = this.items[index];
					if ((item.kind !== null && item.units !== 0) || (item.kind === null && item.units === 0)) {
						valid_count += 1;
					}
				}
			}

			if (this.editItem && !this.isAddTimesheet_local) {
				this.isActive = false;

				if (this.warn_msg.length === 0 && !this.error_duration_over_flag && !this.error_limit_kind_flag && this.job_selected && this.job_selected.id !== 0 && this.job_selected.valid && this.timesheet_date.length !== 0 && this.isValidDurationForSave() && valid_count === this.items.length && !this.isBeyond) {
					if ((this.task && this.task.id !== 0 && this.task.kind !== null ) || (this.kind && this.kind.id !== 0)) {
						if ((!this.time_start && !this.time_end) || (this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0) || (this.time_start && this.time_start.length === 0 && this.time_end && this.time_end.length === 0)) {
							if (this.ts_for && this.ts_for.id !== this.editItem.address_book.id) {
								isActive = true;
							}

							if (typeof(this.ts_type) === 'boolean') {
								if (this.ts_type !== this.editItem.is_freelance) {
									isActive = true;
								}
							} else {
								const old_type = this.editItem.is_freelance === true ? Freelancer_Type : Employee_Type;
								if (this.ts_type !== old_type) {
									isActive = true;
								}
							}
							
							if (this.phase && this.editItem.phase.id !== this.phase.id) {
								isActive = true;
							}
							if (this.editItem.task && this.task && this.editItem.task.id !== this.task.id) {
								isActive = true;
							}
							if (!this.editItem.task && this.task && this.task.id !== 0) {
								isActive = true;
							}
							if (this.editItem.task && this.task_status && this.editItem.task.status_id !== this.task_status.id) {
								isActive = true;
							}
							if (this.kind && this.editItem.kind.id !== this.kind.id) {
								isActive = true;
							}
							if (!this.editItem.kind && this.kind) {
								isActive = true;
							}
							if (this.editItem.date !== moment(this.timesheet_date).format('YYYY-MM-DD')) {
								isActive = true;
							}
							if (this.editItem.notes !== this.notes) {
								isActive = true;
							}
							if (this.editItem.duration !== budgetToMinutes(this.duration)) {
								isActive = true;
							}
							if (this.editItem.start !== null && this.editItem.stop !== null) {
								const start_tmp = moment(this.editItem.start, 'HH:mm:ss').format('h:mm a');
								const end_tmp = moment(this.editItem.stop, 'HH:mm:ss').format('h:mm a');

								if (this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0) {
									if (start_tmp !== this.time_start || end_tmp !== this.time_end) {
										isActive = true;
									}
								}
								
								if (this.time_start && this.time_start.length === 0 && this.time_end && this.time_end.length === 0) {
									isActive = true;
								}
							}
							if (this.editItem.start === null && this.editItem.stop === null) {
								if (this.time_start && this.time_end && this.time_start.length !== 0 && this.time_end.length !== 0) {
									isActive = true;
								}
							}
							if (this.editItem.acoc !== this.ac_oc) {
								isActive = true;
							}
						}
					}
				}
			}

			if (!this.editItem || this.isAddTimesheet_local) {
				if (this.warn_msg.length === 0 && !this.error_duration_over_flag && !this.error_limit_kind_flag && this.job_selected && this.job_selected.id !== 0 && this.job_selected.valid && this.timesheet_date.length !== 0 && this.isValidDurationForSave() && !this.end_time_error && !this.start_time_error && !this.isBeyond) {
					if ((this.task && this.task.id !== 0 && this.task.kind !== null && this.task.kind.id !== null) || (this.kind && this.kind.id !== 0 && this.kind.id !== null)) {
						if ((!this.time_start && !this.time_end) || (this.time_start && this.time_start.length !== 0 && this.time_end && this.time_end.length !== 0) || (this.time_start && this.time_start.length === 0 && this.time_end && this.time_end.length === 0)) {
							if (this.items.length !== 0) {
								if (valid_count === this.items.length) {
									isActive = true;
								}
							} else {
								isActive = true;
							}
						}						
					}
				}
			}
			
			return isActive;
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];

			if (this.job || this.isLogTimesheet) {
				this.$emit('cancel-timesheet');
			} else {
				this.$emit('close');
			}
		},
		_checkLimitKind() {
			if (this.job_selected && this.job_selected.valid && this.job_selected.id !== 0 && this.kind && this.kind.id !== 0 && this.phase && this.phase.id) {
				this._checkKind(this.job_selected.id, this.kind.id, this.phase.id)
					.then(val => {
						if (!val) {
							this.kind = {id: 0, display_name: ''};
							this.kind_selected = {id: 0, display_name: ''};
				
							if (this.limitKindsPrivilege) {
								this.error_limit_kind_flag = true;
							} else {
								this.error_kind_flag = true;
							}
							
							this.isActive = this._isActiveCreateTimesheet();
						}
					})
					.catch((reason) => {
						this.error_msg = reason;
					});
			}
		},
		_removeMsg() {
			this.error_msg = '';
			this.button_click_flag = false;
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		errorMessageFormat(msg) {
			if (msg.length !== 0) {
				this.tid = setTimeout(this._removeMsg, 5000);

				if (msg.includes(config.server_msge_flag)) {
					const msg_arr = msg.split(config.server_msge_flag);
					return msg_arr[1];
				} else {
					return msg;
				}				
			}
		},
		_getTaskStatusColorText(status_id) {
			const filter_arr = this.task_statuses.filter(t => { return t.id === status_id });
			return (filter_arr[0]).color;
		},
		_lowerCase(upcase_obj) {
			const obj = {};
			for(const [key, value] of Object.entries(upcase_obj)) {
				if (typeof(value) === 'object' && value) {
					if (Array.isArray(value)) {
						const array = [];
						value.forEach(v => {
							const v_obj = this._lowerCase(v);
							array.push(v_obj);
						});
						obj[`${key.toLocaleLowerCase()}`] = array;
					} else {
						const value_obj = this._lowerCase(value);
						obj[`${key.toLocaleLowerCase()}`] = value_obj;
					}
				} else {
					obj[`${key.toLocaleLowerCase()}`] = value;
				}
			}
			return obj;
		},
		_checkAutofocusKey() {
			if (this.job_selected === null || (this.job_selected && this.job_selected.id === 0)) {
				if (this.$refs.job) {
					this.$refs.job.focus();
				}
			} else if (!this.editItem && this.kind && (this.kind.id === 0 || this.kind.id === null)) {
				if (this.$refs.kind) {
					const child = this.$refs.kind.$children;
					const input_node = child[0].$children;
					input_node[0].focus();	
				}
			} else if (this.duration !== null && this.duration.length === 0) {
				if (this.$refs.duration) {
					this.$refs.duration.focus();
				}
			}
		},
		_checkKind(job_id, kind_id, phase_id) {
			let url = `/api/jobs/${job_id}/can_do_kind`;

			const params = [];
			params.push("kiid=" + kind_id);
			params.push("jpid=" + phase_id);


			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			return new Promise((resolve, reject) => {
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							if (data.can_do_client && data.can_do_jobtype) {
								if (this.limitKindsPrivilege) {
									if (data.has_quote || data.has_task) {
										resolve(true);
									} else {
										resolve(false);
									}
								} else {
									resolve(true);
								}
								
							} else {
								resolve(false);
							}
							
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});	
		},
		_setWinSetup(job_id, task_id, phase_id, kind_id, kind_display_name) {
			const win_setup_obj = {
				job_id: job_id,
				task_id: task_id,
				phase_id: phase_id,
				kind: {
					id: kind_id,
					display_name: kind_display_name
				}
			};

			const win_setup_str = JSON.stringify(win_setup_obj);

			return win_setup_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.create-task-container {
  background: #FFFFFF;
  border-radius: 4px;
	max-width: 100%;
}
.top-line {
  width: 100%;
  height: 4px;
  background: #81CC00;
  border-radius: 4px 4px 0px 0px;
}
.task-title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title-text {
	font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #81CC00;
}
.job-selected-container {
	width: 100%;
	height: 48px;
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	background-color: #FAFAFA;

	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	color: #192A3E;
}
.job-selected-container-xs {
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-start;
	background-color: #FAFAFA;

	font-family: 'Roboto';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 22px;
	color: #192A3E;
}
.step-item-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #37495F;
}
.step-item-text-hover {
	&:hover {
		cursor: pointer;
	}
}
.step-item-text-able {
	opacity: 0.87;
}
.step-item-text-disable {
	opacity: 0.4;
}
.optional-text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}
.search-text {
  text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}
.duration-text {
	font-family: 'Roboto';
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 20px;
	letter-spacing: 0.4px;
}
.duration-text-over {
	color: #F45252;
}
.duration-text-normal {
	color: #609800;
}
.duration-text-grey {
	color: rgba(25, 42, 62, 0.5);
}
.duration-text-dark-grey {
	color: rgba(25, 42, 62, 0.7);
}
.optional-text-disable {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: rgba(0, 0, 0, 0.38);
}
.search-text-disable {
  text-decoration: underline;
}
.optional-text-red {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;

	color: #F45252;
}
.optional-text-red-keyword {
	text-decoration: underline;
	&:hover {
		cursor: pointer;
	}
}
.tree-wrap {
	height: 300px;
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.for-item-text-hover {
	&:hover {
		cursor: pointer;
		background-color: rgba(25, 42, 62, 0.1);
	}
}
::v-deep {
	.disabled-color.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
		background-color: rgba(129, 204, 0, 0.25) !important;
	}
	.duration.theme--light.v-input input {
		color: #F45252;
	}
}
</style>